import { render, staticRenderFns } from "./FlashModal.vue?vue&type=template&id=6bc21a8c"
import script from "./FlashModal.vue?vue&type=script&lang=js"
export * from "./FlashModal.vue?vue&type=script&lang=js"
import style0 from "./FlashModal.vue?vue&type=style&index=0&id=6bc21a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports